var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLocation1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 1.83398C5.57536 1.83398 3.33203 4.09287 3.33203 6.8701C3.33203 10.8162 7.86203 14.8907 8.05481 15.0618C8.13425 15.1323 8.23314 15.1673 8.33203 15.1673C8.43092 15.1673 8.52981 15.1323 8.60925 15.0623C8.80203 14.8907 13.332 10.8162 13.332 6.8701C13.332 4.09287 11.0887 1.83398 8.33203 1.83398ZM8.33203 9.61176C6.80036 9.61176 5.55425 8.36565 5.55425 6.83398C5.55425 5.30232 6.80036 4.05621 8.33203 4.05621C9.8637 4.05621 11.1098 5.30232 11.1098 6.83398C11.1098 8.36565 9.8637 9.61176 8.33203 9.61176Z",
    fill: "#25368D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.33203,
    cy: 6.83398,
    r: 3,
    fill: "#FBE250"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation1);
export default __webpack_public_path__ + "static/media/icon-location-1.af5f2e93be43f6b518802828360307d4.svg";
export { ForwardRef as ReactComponent };